import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ImportantMessage from './ImportantMessage';
import { updateCSSVar } from '../../utils/cssVarsUtil';

import { useLocalStorage } from '../../hooks/useLocalStorage';
import { StyledImportantMessagesContainer } from './ImportantMessage.styles';
const MESSAGE_HEIGHT = 75;

const combinedId = (message) => {
    return message.id ? `${message.id}-${message.updated}-${message.created}` : undefined;
};

const ImportantMessages = ({ messages }) => {
    const [read, setRead] = useLocalStorage('readImportantMessage', {});
    const readMessages = Object.keys(read);

    useEffect(() => {
        const undReadMessages = messages.filter((message) => !readMessages.includes(combinedId(message)));

        updateCSSVar('important-messages-height', undReadMessages.length * MESSAGE_HEIGHT + 'px');
    }, [messages, readMessages]);

    const handleOnClose = (combinedId) => {
        const newValue = { ...read, [combinedId]: true };
        setRead(newValue);
    };

    if (messages.length === 0) {
        return null;
    }

    return (
        <StyledImportantMessagesContainer>
            {messages.map((message, index) => {
                const id = combinedId(message);
                const isRead = id ? readMessages.includes(id) : false;

                return (
                    <ImportantMessage
                        key={index}
                        {...message}
                        combinedId={combinedId(message)}
                        isRead={isRead}
                        onClose={handleOnClose}
                    />
                );
            })}
        </StyledImportantMessagesContainer>
    );
};

ImportantMessages.propTypes = {
    messages: PropTypes.array,
};

export default ImportantMessages;
